import { Form } from '@openedx/paragon';
import { getErrorMessage } from './form-error.messages';
import { FormErrorProps } from './types';

export const FormError = ({ error, value }: FormErrorProps) => {
  if (!error || typeof error !== 'string') {
    return null;
  }

  return (
    <Form.Control.Feedback type="invalid" hasIcon={false}>
      {getErrorMessage(error, value)}
    </Form.Control.Feedback>
  );
};
